import PageComponent from 'components/Dashboard/PageComponent'
import { Link } from 'gatsby'

const PHE: PageComponent = () => {
  return (
    <>
      <nav className="breadcrumb ml-6" aria-label="breadcrumbs">
        <ul>
          <li>
            <Link to="/dashboard">Dashboard</Link>
          </li>
          <li>
            <a href="/dashboard">Integrations</a>
          </li>
          <li className="is-active">
            <a href={`/dashboard/phe`} aria-current="page">
              PHE
            </a>
          </li>
        </ul>
      </nav>

      <section className="section is-small">
        <div className="container">
          <h1 className="title">PHE</h1>

          <Link to="/dashboard/phe/day2and8salescounts">Day 2 & 8 Sales Counts</Link>
        </div>
      </section>
    </>
  )
}

PHE.path = '/phe'
PHE.displayName = 'PHE'

export default PHE
